import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfigService } from '../app-config/app-config-service';
import { AdminHeaderInterceptor } from '../http-interceptors/admin-header-interceptor';
import { AppVersionInterceptor } from '../http-interceptors/app-version-interceptor';
import { AuthInterceptor } from '../http-interceptors/authentication-interceptor';
import { BlobErrorHttpInterceptor } from '../http-interceptors/blob-error-http-interceptor';
import { CamelCaseInterceptor } from '../http-interceptors/camel-case-interceptor';
import { GraphQLErrorHttpInterceptor } from '../http-interceptors/graphql-error-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: CamelCaseInterceptor },
   // The auth interceptor wraps the app version interceptor, because both of these interceptors
   // delegate to the next interceptor before doing anything, so the actual execution order is
   // the app version interceptor then the auth interceptor (the opposite of the order in this array).
   // By running the app version interceptor first we ensure that the auth interceptor doesn't
   // swallow 401 responses that also happen to have a new version header. The result is that
   // the 'update' dialog will show up even on 401 responses.
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor },
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: AppVersionInterceptor },
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor },
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: AdminHeaderInterceptor, deps: [AppConfigService] },
   { multi: true, provide: HTTP_INTERCEPTORS, useClass: GraphQLErrorHttpInterceptor },
];
